'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dataset = require('./dataset');

var _record = require('./record');

/**
 * Generates selectors with the provided config
 * @param  {Object} config - selector configuration
 *
 * @return {Object} - Set of selectors
 */
var selectors = function selectors(config) {
  if (!config) throw new Error('clerk.selectors: Expected config');
  if (!config.baseSelector) throw new Error('clerk.selectors: Expected baseSelector');

  return {
    dataset: _dataset.datasetSelector.bind(null, config),
    datasetOptimistic: _dataset.datasetOptimisticSelector.bind(null, config),
    datasetProperty: _dataset.datasetPropertySelector.bind(null, config),
    record: _record.recordSelector.bind(null, config),
    recordOptimistic: _record.recordOptimisticSelector.bind(null, config),
    recordState: _record.recordStateSelector.bind(null, config)
  };
};

exports.default = selectors;